import BaseLoader from "./BaseLoader";

class MultipleOfferTemplatLoader extends BaseLoader{
    constructor(...arg){
        super(...arg)
    }

    createTemplate(campaignList, unit){
        const tpl = new this.templateClass({
            container: this.rootWebview,
            campaignList,
            unit
        })
        tpl.init()
        return tpl
    }
}

export default MultipleOfferTemplatLoader